import React from "react";
import { CardBox, Data, Loading, Title } from "../../components";
import { Col, Row } from "../../Tools/Grid-system";
import { useFETCH, useFilter } from "../../Tools/APIs/useMyAPI";
import Pagination from "../../Tools/Pagination";

const Message = () => {
  const { filter } = useFilter({});
  const { data, isLoading, deleteItem } = useFETCH(
    `messages?page=${filter.get("page") ? filter.get("page") : 1}`,
    "messages"
  );
  return (
    <>
      <Title title="الرسائل" />
      {isLoading ? <Loading /> : ""}
      <Pagination
        pageCount={Math.ceil(data?.data.data?.total / data?.data.data.per_page)}
      >
        <Row>
          {data?.data.data.data?.map((e) => (
            <Col lg={4} md={6} key={e.id}>
              <CardBox showEdit={true} deleteClick={() => deleteItem(e)}>
                <Data name="الاسم" text={e.name} />
                <Data name="الموقع المفضل" text={e.preferred_location} />
                <Data name="الموقع" text={e.location} />
                <Data name="رقم الهاتف" text={e.phone_number} />
                <Data name="الرسائل" text={e.description} />
              </CardBox>
            </Col>
          ))}
        </Row>
      </Pagination>
    </>
  );
};

export default Message;
